import { z } from 'zod';
import { metadata } from './helpers';
import { contentBase } from './content';

export const processStepContentSchema = z.object({
  metadata: metadata,
  data: z.array(
    z.object({
      title: z.string(),
      subtitle: z.string(),
      url: z.string(),
      position: z.number(),
      image: z.string(),
    })
  ),
});

export const contentTypeProcessStepContentSchema = contentBase.extend({
  content: processStepContentSchema,
});

export type ContentTypeProcessStepContentInput = z.infer<
  typeof contentTypeProcessStepContentSchema
>;
